import { useFeature } from 'src/app/FeatureToggle/useFeature';
import { Alert } from 'src/common/Alert/Alert';

import { TransferAssignmentAction } from '../TransferAssignmentAction';

export function TransferAssignmentAlert() {
  const { isEnabled, isLoading } = useFeature('transfer assignment');

  if (isLoading || !isEnabled) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <Alert
        message="To change the vehicle for a crew schedule that has started, click Transfer Crew Schedule"
        severity="warning"
      />
      <div className="flex justify-end">
        <TransferAssignmentAction />
      </div>
    </div>
  );
}
